(function () {
  // Mouse-only drag-to-scroll. Touch/pen already get native scrolling
  // (overflow-x: auto) — hijacking those pointer types here would fight
  // the browser's own momentum scroll and scroll-snap handling.
  var DRAG_THRESHOLD = 6;
  var DESKTOP_QUERY = '(min-width: 1024px)';

  function setScrollLeft(track, left) {
    if (typeof track.scrollTo === 'function') {
      track.scrollTo({ left: left, behavior: 'auto' });
    } else {
      track.scrollLeft = left;
    }
  }

  function settleSnap(track) {
    if (typeof track.scrollTo !== 'function') return;
    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({
      left: track.scrollLeft + 1,
      behavior: reduce ? 'auto' : 'smooth',
    });
  }

  function openOnSecondCard(track) {
    // Spec: on desktop, the "current" card sits fully visible and
    // centered, with the previous and next cards cropped symmetrically
    // at the module edges — a center-focus carousel (`scroll-snap-align:
    // center` in the CSS), not a flush-start scrolling list.
    //
    // At scrollLeft: 0 the *first* card would be the one centered, which
    // leaves nothing to crop on its left (there's no card before it) —
    // so both edges only show cropped from the first paint if the
    // second card opens as the centered one instead, since it has a real
    // neighbor on both sides.
    //
    // This targets the second card directly (by measured position, not
    // a generic offset) rather than reproducing a fixed pixel value:
    // reliable regardless of card width/gap/viewport, and it's exactly
    // where native center-snap would settle anyway. Selects by class,
    // not track.children[1] — the leading .cards-product-carousel__spacer
    // (mobile-only, hidden on desktop) would otherwise shift the index.
    if (!window.matchMedia(DESKTOP_QUERY).matches) return;
    var card = track.querySelectorAll('.cards-product-carousel__card')[1];
    if (!card) return;
    setScrollLeft(
      track,
      card.offsetLeft + card.offsetWidth / 2 - track.clientWidth / 2
    );
  }

  function resetMobileScroll(track) {
    // Mobile keeps the M27-style leading spacer (first card gets the
    // page's own left margin instead of bleeding flush) — same fix as
    // cards-categories.js needed: browsers restore a scrollable
    // element's previous scrollLeft on reload/back-forward navigation
    // independent of layout, which makes that spacer look "missing"
    // until the user scrolls. Force it back to the true start.
    if (window.matchMedia(DESKTOP_QUERY).matches) return;
    setScrollLeft(track, 0);
  }

  function initTrack(track) {
    var pointerId = null;
    var startX = 0;
    var startScrollLeft = 0;
    var dragged = false;
    var suppressClick = false;

    function onPointerMove(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      var delta = event.clientX - startX;
      if (!dragged) {
        if (Math.abs(delta) <= DRAG_THRESHOLD) return;
        dragged = true;
        track.classList.add('is-dragging');
        // Capture only after a real drag so a still press keeps pointerup
        // on the card <a> and the following click can navigate.
        if (typeof track.setPointerCapture === 'function') {
          track.setPointerCapture(pointerId);
        }
      }
      track.scrollLeft = startScrollLeft - delta;
    }

    function endDrag(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      var wasDragged = dragged;
      if (
        typeof track.hasPointerCapture === 'function' &&
        track.hasPointerCapture(pointerId)
      ) {
        track.releasePointerCapture(pointerId);
      }
      pointerId = null;
      dragged = false;
      track.classList.remove('is-dragging');
      if (wasDragged) {
        suppressClick = true;
        window.setTimeout(function () {
          suppressClick = false;
        }, 0);
        settleSnap(track);
      }
      track.removeEventListener('pointermove', onPointerMove);
      track.removeEventListener('pointerup', endDrag);
      track.removeEventListener('pointercancel', endDrag);
    }

    function onClickCapture(event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
    }

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      dragged = false;
      track.addEventListener('pointermove', onPointerMove);
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
    });

    track.addEventListener('click', onClickCapture, true);

    // Cards are <a> elements wrapping an <img> — browsers start their own
    // native drag-and-drop gesture on those by default, which preempts
    // pointer events mid-press and makes the custom drag above feel like
    // it "doesn't work" whenever the press starts on the link/image.
    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    resetMobileScroll(track);
    openOnSecondCard(track);
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        resetMobileScroll(track);
        openOnSecondCard(track);
      });
    }
  }

  function init() {
    document
      .querySelectorAll('.cards-product-carousel__track')
      .forEach(initTrack);
  }

  document.addEventListener('shopify:section:load', init);

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) init();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
